var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysServiceTypeFlight = function SvgSysServiceTypeFlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sysServiceTypeFlight_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C8E7CA",
    d: "M8 1.333A6.667 6.667 0 1 0 14.667 8 6.674 6.674 0 0 0 8 1.333ZM8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4BAF4F",
    d: "M4.391 11.203a1.722 1.722 0 0 1-1.533-.781.333.333 0 0 1 .057-.4l.237-.232-.718-.705a.333.333 0 0 1 .087-.538l.963-.47a.333.333 0 0 1 .25-.018l1.316.429 1.38-.674-2.066-2.021a.333.333 0 0 1 .232-.572h1.445c.05 0 .1.011.146.034l2.768 1.352 2.747-.894c.207-.09.43-.138.656-.14a1.295 1.295 0 0 1 1.208.781.977.977 0 0 1 .066.658.446.446 0 0 1-.232.256l-8.186 3.763c-.259.116-.54.174-.823.172Zm-.791-.92c.227.172.506.262.791.253.187.002.373-.035.545-.11l8.052-3.702a.636.636 0 0 0-.633-.487c-.14.002-.278.033-.406.091l-.03.011-2.889.941a.333.333 0 0 1-.249-.017l-2.82-1.378h-.55l1.823 1.783a.333.333 0 0 1-.086.538l-1.927.94a.333.333 0 0 1-.25.018l-1.316-.429-.417.204.625.61a.333.333 0 0 1 0 .476l-.263.258Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sysServiceTypeFlight_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSysServiceTypeFlight;